'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.navigation = twentyninetimes.navigation || function () {

	function init() {
		const site_nav = document.getElementById('js-site-nav');

		if ( site_nav ) {
			siteNav(site_nav);
			subMenuToggle(site_nav);

			// if ( window.innerWidth > 991 ) {
			// 	megaMenuToggle();
			// }
		}
		
		headerInit();
		headerScroll();
	}

	function siteNav(site_nav) {
		var site_body		= document.body,
			nav_toggle 		= document.getElementById('js-mobile-nav-toggle');

		nav_toggle.addEventListener('click', function(event) {
			event.stopPropagation();

			var btn = event.target,
				site_nav_item = site_nav.querySelectorAll('.site-nav__inner > ul > .menu-item'),
				i = 0;

			if ( !site_body.classList.contains('nav-active') ) {

				site_body.classList.add('nav-active');

				// Disable scrolling
				site_body.classList.add('no-scroll');
				bodyScrollLock.disableBodyScroll(site_nav);

				function site_nav_item_timeout(i) {
					setTimeout(function() {
						site_nav_item[i].classList.add('visible');
					}, i*50);
				}

				for (i = 0; i < site_nav_item.length; i++) { 
					site_nav_item_timeout(i);

					// var current = site_nav_item[i];

					// if ( !current.classList.contains('open') && current.classList.contains('current-menu-ancestor') ) {
					// 	var current_open = current,
					// 	sub_menu = current.querySelector('.sub-menu-wrap');
					
					// 	sub_menu.style.height = '100%';
					// 	var height = sub_menu.scrollHeight + 'px';
					// 	sub_menu.style.height = '';

					// 	sub_menu.style.height = height;
					// 	current_open.classList.add('open');
					// }
				}

				i = 0;
			} else {
				for (i = 0; i < site_nav_item.length; i++) { 
					site_nav_item[i].classList.remove('visible');
				}
				
				i = 0;

				site_body.classList.remove('nav-active');

				// Re-activate scrolling
				site_body.classList.remove('no-scroll');
				bodyScrollLock.enableBodyScroll(site_nav);
			}
		});
	}

	function subMenuToggle(site_nav) {
		var site_nav_item = site_nav.getElementsByClassName('menu-item-has-children');

		if ( site_nav_item ) {
			for (var i = 0; i < site_nav_item.length; i++) {
				var sub_menu_toggle = site_nav_item[i].querySelector('.js-sub-menu-toggle');

				sub_menu_toggle.addEventListener('click', function() {
					var nav_item = this.parentElement,
						sub_menu = nav_item.querySelector('.sub-menu-wrap');

					if ( !nav_item.classList.contains('open') ) {
						sub_menu.style.height = '100%';
						var height = sub_menu.scrollHeight + 'px';
						sub_menu.style.height = '';

            nav_item.classList.add('open');

						setTimeout(function() {
              sub_menu.style.height = height;
            }, 50);
					} else {
						sub_menu.style.height = '0px';
						nav_item.classList.remove('open');
					}

				});
			}
		}
	}

	function headerScroll() {
		// Hide Header on on scroll down
		var didScroll,
			lastScrollTop = 0,
			delta = 5,
			navbar = document.getElementById('js-site-header'),
			navbarHeight = navbar.clientHeight - 40;

		document.addEventListener('scroll', function (e) {
		    didScroll = true;
		});

		setInterval(function() {
		    if ( didScroll ) {
		        hasScrolled();
		        didScroll = false;
		    }
		}, 100);

		function hasScrolled() {
		    var scroll_top = window.scrollY;      
		    
		    // If they scrolled down and are past the navbar, add class .nav-up.
		    // This is necessary so you never see what is "behind" the navbar.
		    if ( scroll_top > navbarHeight ) {
		        // Scroll Down
		        navbar.classList.add('scrolled');
		        return;
		    } else {
	            navbar.classList.remove('scrolled');
		    }
		    
		    lastScrollTop = scroll_top;
		}
    }

    function headerInit() {
    	var navbar 			= document.getElementById('js-site-header'),
			navbarHeight 	= navbar.clientHeight - 40,
			scroll_top 		= window.scrollY;

		if ( scroll_top > navbarHeight ) {
		    // Scroll Down
		    navbar.classList.add('scrolled');
		}
    }

    function megaMenuToggle() {
    	var siteHeader 			= document.getElementById('js-site-header'),
    		siteNavItems 		= siteHeader.querySelectorAll('.site-nav__inner > ul > .menu-item-has-children'),
    		menuBg 				= siteHeader.querySelector('.menu-bg');
    	
    	siteNavItems.forEach(menu_item => {
    		menu_item.addEventListener('mouseenter', (e)=>{
    			var subMenu 	= event.target.querySelector('.sub-menu-wrap'),
    				subHeight 	= subMenu.clientHeight;
    			
    			menuBg.style.height = subHeight+'px';

    			classToggle(siteHeader);
    		});

    		menu_item.addEventListener('mouseleave', ()=>{
				menuBg.style.height = '0px';

				classToggle(siteHeader);
    		});
    	});

    	function classToggle(siteHeader) {
    		if ( !siteHeader.classList.contains('mega-menu-active') ) {
    			siteHeader.classList.add('mega-menu-active');
    		} else {
    			siteHeader.classList.remove('mega-menu-active');
    		}
    	}
    }

	return {
		init : init
	};

}();